import get from 'lodash.get';

const premiumIconsLimit = ({ targetPackage }) => ({
  available: get(targetPackage, 'features.premiumIcons', false),
});

export default premiumIconsLimit;
